import React from "react";
import { Route, Routes } from "react-router-dom";

import OrderDetails from "@/components/screens/OrderDetails";
import OrderFormPage from "@/components/screens/OrderFormPage";
import Orders from "@/components/screens/Orders";
import { ORDER_DETAILS_MESSAGES } from "@/messages/order-details/order-details.messages";
import { ORDER_FORM_PAGE_MESSAGES } from "@/messages/order-form-page/order-form-page.messages";
import { ORDERS_MESSAGES } from "@/messages/orders/order.messages";

const OrdersPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:lang" element={<Orders messages={ORDERS_MESSAGES} />} />
      <Route path="/create/:lang" element={<OrderFormPage messages={ORDER_FORM_PAGE_MESSAGES} />} />
      <Route
        path="/edit/:orderId/:lang"
        element={<OrderFormPage messages={ORDER_FORM_PAGE_MESSAGES} isEditing />}
      />
      <Route
        path="/details/:orderId/:lang"
        element={<OrderDetails messages={ORDER_DETAILS_MESSAGES} />}
      />
      <Route
        path="/print/:orderId/:lang"
        element={<OrderDetails messages={ORDER_DETAILS_MESSAGES} isPrint />}
      />
      <Route path="/" element={<Orders messages={ORDERS_MESSAGES} />} />
    </Routes>
  );
};

export default OrdersPage;
